import { render, staticRenderFns } from "./enclosureAdd.vue?vue&type=template&id=3547eefa&scoped=true&"
import script from "./enclosureAdd.vue?vue&type=script&lang=js&"
export * from "./enclosureAdd.vue?vue&type=script&lang=js&"
import style0 from "./enclosureAdd.vue?vue&type=style&index=0&id=3547eefa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547eefa",
  null
  
)

export default component.exports